import { useEffect, useState } from "react";
import instance from "./Api";
import Skeleton from "@mui/material/Skeleton";

export default function Image({ src, alt, className, onError, width, height }) {
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(true); // Track whether the image has loaded
    const token = localStorage.getItem('token');

    useEffect(() => {
        const loadImage = async () => {
            setLoading(true); // Start showing the skeleton while fetching
            try {
                const response = await instance.get(
                    `/S3Image/getSignedImage?image=${src}`
                );
                setUrl(response.data.image);
            } catch (error) {
                console.error("Error loading image:", error);
                setLoading(false); // Stop loading on error
            }
        };

        if (src) {
            loadImage();
        }
    }, [src, token]);

    return (
        <>
            {loading && <Skeleton variant="rounded" width={width} height={height} />}
            {url && (
                <img
                    src={url}
                    alt={alt}
                    className={className}
                    onLoad={() => setLoading(false)} // Hide the skeleton once the image loads
                    onError={onError}
                    style={{ display: loading ? "none" : "block" }} // Ensure skeleton and image don't overlap
                    width={width}
                    height={height}
                />
            )}
        </>
    );
}
